import { Integration } from '@firmable/contracts';

type SupportedCRMProviders = Extract<CRMSupported, 'hubspot' | 'salesforce'>;

type CRMObjectTypeMap = {
  hubspot: Integration.Hubspot.HubspotObjectType;
  salesforce: Integration.SF.SalesforceObjectType;
};

type FBLCRMObjectMap = Integration.Common.CRMObjectMap;

type FBLCategoryToCRMCategory = {
  [CRM in SupportedCRMProviders]: CRM extends keyof FBLCRMObjectMap
    ? { [Obj in FBLCRMObjectMap[CRM]]: CRMObjectTypeMap[CRM] }
    : never;
};

/**
 * Maps FBL category (company/contact/lead) to CRM-specific category per provider.
 * e.g. hubspot.company → 'company', salesforce.company → 'account'
 */
const fblCategoryToCrmCategory: FBLCategoryToCRMCategory = {
  hubspot: {
    company: 'company',
    contact: 'contact',
  },
  salesforce: {
    company: 'account',
    contact: 'contact',
    lead: 'lead',
  },
};

/**
 * Returns the CRM-specific category for a given provider and FBL category.
 */
const getCrmCategory = (crm: SupportedCRMProviders, category: string): CRMObjectTypeMap[typeof crm] => {
  return fblCategoryToCrmCategory[crm][category as keyof (typeof fblCategoryToCrmCategory)[typeof crm]];
};

/**
 * Batch sizes per CRM provider for Paragon app events.
 */
const batchSize: Record<SupportedCRMProviders, number> = {
  hubspot: 400,
  salesforce: 500,
};

export { batchSize, fblCategoryToCrmCategory, getCrmCategory };
export type { SupportedCRMProviders };
